import { __extends } from "tslib";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
import { DescribeTrackerRequest, DescribeTrackerResponse } from "../models/models_0";
import { deserializeAws_restJson1DescribeTrackerCommand, serializeAws_restJson1DescribeTrackerCommand, } from "../protocols/Aws_restJson1";
var DescribeTrackerCommand = (function (_super) {
    __extends(DescribeTrackerCommand, _super);
    function DescribeTrackerCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    DescribeTrackerCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "DescribeTrackerCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DescribeTrackerRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DescribeTrackerResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeTrackerCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1DescribeTrackerCommand(input, context);
    };
    DescribeTrackerCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1DescribeTrackerCommand(output, context);
    };
    return DescribeTrackerCommand;
}($Command));
export { DescribeTrackerCommand };
